import * as React from 'react';

import { ReMatterLogo, cn } from '@rematter/ui-web';
import { useAtom } from 'jotai';

import { EmailVerification } from './components/EmailVerification';
import { OrganizationSelection } from './components/OrganizationSelection';
import { SignInCredentials } from './components/SignInCredentials';
import { SuccessAnimation } from './components/SuccessAnimation';
import { Totp } from './components/Totp';
import { $signIn } from './state/signIn.state';

import { useTranslations } from '~/app/i18n/useTranslations';
import { useIdentity } from '~/shared/hooks';

export const SignIn = () => {
  const t = useTranslations();
  const [signInState, setSignInState] = useAtom($signIn);

  const { accessToken } = useIdentity();

  React.useEffect(() => {
    if (!accessToken) {
      setSignInState({
        step: 'credentials',
        authenticated: false,
      });
    }
  }, [accessToken, setSignInState]);

  const renderStep = () => {
    if (signInState.authenticated) {
      return <SuccessAnimation message={t.signIn.success} />;
    }

    switch (signInState.step) {
      case 'email-verification':
        return <EmailVerification />;
      case 'mfa-enroll':
      case 'mfa-challenge':
        return <Totp />;
      case 'org-selection':
        return <OrganizationSelection />;
      case 'credentials':
      default:
        return <SignInCredentials />;
    }
  };

  return (
    <div
      className={cn(
        '@SignIn',
        'relative flex min-h-screen items-center justify-center overflow-hidden p-5',
        'bg-gradient-to-b from-foreground/4 to-foreground/8',
      )}
    >
      <div
        className={cn(
          'relative z-10 flex w-full max-w-[400px] flex-col rounded-xl border border-abs-white/20 bg-space p-10 shadow-2xl shadow-primary/10 transition-[height] duration-300',
        )}
      >
        <div className="mb-6 flex justify-center">
          <ReMatterLogo size="large" height={50} />
        </div>
        {renderStep()}
      </div>
    </div>
  );
};
